import { initializeApp } from 'firebase/app'
import { getAuth } from "firebase/auth"
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from "firebase/analytics"
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'

export default defineNuxtPlugin(nuxtApp => {
    const config = useRuntimeConfig()

    const firebaseConfig = {
      apiKey: "AIzaSyCQv-tJ3luiD_fve1RpQTD1kdsbCQvJJI8",
      authDomain: "brx-please-reply.firebaseapp.com",
      databaseURL: "https://brx-please-reply-default-rtdb.firebaseio.com",
      projectId: "brx-please-reply",
      storageBucket: "brx-please-reply.firebasestorage.app",
      messagingSenderId: "877999151749",
      appId: "1:877999151749:web:f64c3bfa6d088beed427ec",
      measurementId: "G-JTC8M50NR1"
    };

    const fbapp = initializeApp(firebaseConfig)

    // console.log("FIREBASE STARTING")
    // console.log(app)

    // const analytics = getAnalytics(app)
    const auth = getAuth(fbapp)
    const firestore = getFirestore(fbapp)
    const realtimeDb = getDatabase(fbapp)
    const storage = getStorage(fbapp)


    // console.log("INIT SERVICE")
    // console.log(auth)
    // console.log(firestore)

    // nuxtApp.vueApp.provide('app', fbapp)
    // nuxtApp.provide('app', fbapp)

    // nuxtApp.vueApp.provide('auth', auth)
    // nuxtApp.provide('auth', auth)

    // nuxtApp.vueApp.provide('firestore', firestore)
    // nuxtApp.provide('firestore', firestore)
    
    // nuxtApp.vueApp.provide('realtimeDb', realtimeDb)
    // nuxtApp.provide('realtimeDb', realtimeDb)

    // nuxtApp.vueApp.provide('storage', storage)
    // nuxtApp.provide('storage', storage)

    return {
      provide: {
        fbapp,
        auth,
        firestore,
        realtimeDb,
        storage
      }
  }
})
